import React, { ForwardedRef, forwardRef, useEffect } from 'react';
import { Box, IconButton, Typography, Paper, MenuItemTypeMap } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { green } from '@mui/material/colors';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useEasyBrowserContext } from '../browser';
import { MenuItemType } from './taskbartypes.d';


const ItemTask = forwardRef(({ itemMenu }: { itemMenu: MenuItemType }, _ref: ForwardedRef<any>) => {

  const { fecharPagina, abrirPagina, taskSelecionada } = useEasyBrowserContext()!;




  return (


    <Box
      ref={_ref}
      sx={{
        display: 'flex',
        height: 'calc(30px)',
        width: '150px',
        minWidth: '150px',
        overflow: 'hidden',
        alignItems: 'center',
        position: 'relative',
        borderRadius: 1,
        borderRight: '2px solid rgba(0, 0, 0, 0.1)',
        borderBottom: '2px solid rgba(0, 0, 0, 0.1)',
        bgcolor: taskSelecionada?.id === itemMenu.id ? 'rgba(29, 231, 79, 0.1)' : 'var(--color-suave)',
        ":hover": {
          cursor: 'pointer',
          bgcolor: 'var(--cor-destaque)',
        },

      }}
      onClick={(e) => { abrirPagina(itemMenu); e.stopPropagation() }}

    >

      <Typography
        variant="subtitle1"
        noWrap
        sx={{
          color: 'black',
          userSelect: 'none',
          width: 'calc(100% - 30px)',
          whiteSpace: 'wrap',
          textAlign: 'start',
          margin: '5px',
          fontSize: '14px',
          fontfamily: "'Segoe UI', Tahoma, Geneva, sans-serif",
          textWrap: 'nowrap',
          
          "&:hover": {
            cursor: 'pointer',
            color: 'green',
          },

        }}
        title={itemMenu.descricao}
      >
        {itemMenu.descricao}
      </Typography>



      <CloseIcon onClick={(e) => { fecharPagina(itemMenu); e.stopPropagation() }} sx={{
        position: 'absolute',
        right: 5,
        color: 'black',
        width: '10px',
        opacity: '0.5',
        ":hover": {
          cursor: 'pointer',
          opacity: '1',
        },
      }}
      />


    </Box>
  );
});

export default ItemTask;
